module.exports = __webpack_public_path__ + "media/images/help/material-856a9cc776f9ee70af80538a4d2eaf34.png";